import Vue from 'vue';

const success = (response, context, user) => {
  user.avatar = response.data.image;
  user.avatarPath = response.data.path;
  context.image = null;
  context.loading = false;
  toastr.success(response.data.msg);
};

const failed = (error, context) => {
  if (error.response) {
    context.loading = false;
    context.toastr.error(error.response.data.msg.image[0]);
  }
};

export default (context, user) => Vue.$http.delete(`/delete-avatar/${user.id}`).then((response) => {
  if (response && response.status === 200) {
    success(response, context, user);
  }
}).catch((error) => {
  failed(error, context);
});



// WEBPACK FOOTER //
// ./src/app/services/account/deleteAvatar.js